const decimalFormatter = new window.TwitterCldr.DecimalFormatter();
const currencyFormatter = new window.TwitterCldr.CurrencyFormatter();
const dateTimeFormatter = new window.TwitterCldr.DateTimeFormatter();
const timespanFormatter = new window.TwitterCldr.TimespanFormatter();

export default {
  calendar: window.TwitterCldr.Calendar,
  formatCurrency(amount, currency) {
    return currencyFormatter.format(amount, { currency });
  },
  formatDateTime(date, options) {
    return dateTimeFormatter.format(date, options);
  },
  formatDecimal(value, precision) {
    return decimalFormatter.format(value, { precision });
  },
  formatTimespan(time, options) {
    return timespanFormatter.format(
      time - Math.round(Date.now() / 1000),
      options
    );
  }
};
